import React, { useState } from 'react';
import { lighten } from 'polished';
import { Collapse } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import WalletIcon from 'mdi-react/WalletIcon';
// import { disconnectWallet } from '@/redux/actions/walletActions';

import { disconnectWallet } from 'src/redux/walletActions';

// import {
//  colorBackground, colorHover, colorDarkText, colorBorder, colorGray,
// } from '@/utils/palette';

import {
  colorBackground, colorHover, colorDarkText, colorBorder, colorGray,
 } from 'src/containers/LayoutNew/scrollBar/palette';

// import { marginLeft, right, left } from '@/utils/directions';

import { marginLeft, right, left } from 'src/containers/LayoutNew/scrollBar/directions';

// import { TopbarBack, TopbarDownIcon } from './BasicTopbarComponents';

import { TopbarBack, TopbarDownIcon } from 'src/containers/LayoutNew/components/topbar/BasicTopbarComponents';

// import TopbarMenuLink, { TopbarLink } from './TopbarMenuLink';

import TopbarMenuLink, { TopbarLink } from 'src/containers/LayoutNew/components/topbar/TopbarMenuLink';



const TopbarMetaMask = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const idWallet = useSelector(state => state.wallet.id);

  const dispatch = useDispatch();

  const toggleProfile = () => {
    setIsCollapsed(!isCollapsed);
  };

  const disconnect = () => {
    dispatch(disconnectWallet());
  };

  return (
    <TopbarProfileWrap>
      <TopbarMetaMaskButton type="button" onClick={toggleProfile}>
        <WalletIcon />
        <TopbarMetaMaskId>
          {`${idWallet.slice(0, 2)}...${idWallet.slice(-5, -1)}`}
        </TopbarMetaMaskId>
        <TopbarDownIcon />
      </TopbarMetaMaskButton>
      {isCollapsed && (
        <TopbarBack
          type="button"
          aria-label="profile button"
          onClick={toggleProfile}
        />
      )}
      <Collapse in={isCollapsed}>
        <TopbarMenuWrap>
          <TopbarMenu>
            <TopbarMenuLink
              title="Wallet"
              path="/account/profile"
              onClick={toggleProfile}
            />
            <TopbarMenuLink
              title="Recent transactions"
              path="/default_pages/calendar"
              onClick={toggleProfile}
            />
            <TopbarMenuDivider />
            <TopbarMenuLink
              title="Disconnect"
              icon="exit"
              path="/connect_wallet"
              onClick={disconnect}
              iconright
            />
          </TopbarMenu>
        </TopbarMenuWrap>
      </Collapse>
    </TopbarProfileWrap>
  );
};

export default TopbarMetaMask;

// region STYLES

const TopbarProfileWrap = styled.div`
  position: relative;
  margin-bottom: 0;
  ${marginLeft}: 0px;

  @media screen and (max-width: 576px) {
    margin: inherit;
  }

  @media screen and (max-width: 320px) {
    margin: auto 0;
  }
`;

const TopbarMetaMaskButton = styled.button`
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  border-radius: 0;
  border: none;
  transition: all 0.3s;
  box-shadow: none;
  background-color: transparent;

  &:hover, &:focus, &:active, &:focus:active {
    background-color: ${colorHover};
  }

  &:focus {
    outline: none;
  }

  &:before {
    display: none;
  }

  svg {
    margin: auto;
    height: 18px;
    width: 18px;
    fill: ${lighten(0.25, colorGray)};
  }
`;

const TopbarMetaMaskId = styled.p`
  margin: auto 0;
  font-size: 14px;
  line-height: 18px;
  font-weight: 500;
  display: flex;
  ${marginLeft}: 10px;
  color: ${colorDarkText};

  @media screen and (min-width: 480px) {
      display: block;
  }
`;

const TopbarMenuWrap = styled.div`
  z-index: 101;
  position: absolute;
  width: 100%;
  min-width: 210px;
  ${right}: 0px;

  @media screen and (max-width: 320px) {
    ${right}: -50px;
  }
`;

const TopbarMenu = styled.div`
  width: 200px;
  border-radius: 0;
  border: none;
  padding: 15px 0;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.05);
  margin-top: 0;
  background: ${colorBackground};

  button {
    padding: 0;

    &:hover {
      background-color: ${colorHover};
    }

    &${TopbarLink} {
      background-color: transparent;
      border: none;
      padding: 9px 20px;
    }
  }

  *:focus {
    outline: none;
  }

  @media screen and (min-width: 480px) {
    width: 100%;
    ${left}: 0px !important;
  }
`;

const TopbarMenuDivider = styled.div`
  margin: 15px 0;
  border-top: 1px solid ${colorBorder};
`;

// endregion
